import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Station } from 'src/app/interfaces/station.interface';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  @Input() station: Station;
  stationName!: string;

  currentYear: number = new Date().getFullYear();

  constructor(
  private router: Router,
  ) { }

  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges): void {
   if (changes['station']) {
     this.station = this.station;
     if (!this.station) {
      this.stationName = environment.name;
     }
   }
  }

  goPolicy() {
    this.router.navigate(['policy']);
  }

  goTerms() {
    this.router.navigate(['terms']);
  }

}
